import { IconSize } from '@ardoq/icons';
import styled from 'styled-components';

export const ImageOption = styled.img`
  height: ${IconSize.LARGE}px;
  width: ${IconSize.LARGE}px;
  object-fit: contain;
`;
ImageOption.displayName = 'ImageOption';
